export interface FeatureCard {
  id: number;
  title: string;
  features: string[];
  benefit: string;
}

export const cardsData: FeatureCard[] = [
  {
    id: 1,
    title: "Secure, Modular Infrastructure",
    features: [
      "Runs complex workloads across cloud, on-prem, and hybrid models.",
      "Built-in governance, cost visibility and compliance",
    ],
    benefit: "Scales seamlessly while ensuring compliance and trust",
  },
  {
    id: 2,
    title: "Unified Data Foundation",
    features: [
      "Integrates fragmented data sources into a unified semantic context",
      "Provides a single, governed source of truth",
    ],
    benefit: "Harmonizes enterprise data and eliminates silos",
  },
  {
    id: 3,
    title: "Ontology - Driven Intelligence",
    features: [
      "Runs complex workloads across cloud, on-prem, and hybrid models",
      "Built-in governance, cost visibility and compliance",
    ],
    benefit: "Scales seamlessly while ensuring compliance and trust",
  },
  {
    id: 4,
    title: "Data Preparation & Quality Engine",
    features: [
      "Integrates fragmented data sources into a unified semantic context",
      "Provides a single, governed source of truth",
    ],
    benefit: "Harmonizes enterprise data and eliminates silos",
  },
  {
    id: 5,
    title: "Adaptive AI Agents",
    features: [
      "Deploys configurable agents that reason across data",
      "Executes end-to-end tasks autonomously",
    ],
    benefit: "Automates workflows, reducing manual effort and delay",
  },
  {
    id: 6,
    title: "Conversational & Visual Analytics",
    features: [
      "Natural language querying and instant visualization",
      "Full BI and SQL integration for technical teams",
    ],
    benefit: "Democratizes analytics while preserving depth and control",
  },
];

export const sectionTitle = "Platform features & benefits";
